import { VehicleRowGroup } from 'src/pages/ConvenienceDispatches/adapter';

/**
 * 「全選択」の対象になる行 ID。
 *
 * 固定ルート合成行 (`isPlaceholderRow=true && !isExtraRotation`) は実在する delivery が
 * 無いので除く。選んでも配車できず、件数だけ増えて「N件選択中」が実態とずれる。
 * ローカル追加した 2 回転目以降 (`isExtraRotation=true`) は同 truck の代表 delivery に
 * ぶら下げて配車できるので含める。
 */
export function collectSelectableRowIds(rowGroups: VehicleRowGroup[]): string[] {
  return rowGroups.flatMap((group) => group.rows
    .filter((r) => !r.source.isPlaceholderRow || r.source.isExtraRotation === true)
    .map((r) => r.rowId));
}

/**
 * 全選択済みか。対象ゼロを true にしない（空の画面でボタンが「全解除」になってしまう）。
 * 選択集合に対象外の id（placeholder 行など）が混ざっていても判定は変えない。
 */
export function allRowsSelected(selectableRowIds: string[], selectedRowIds: Set<string>): boolean {
  return selectableRowIds.length > 0 && selectableRowIds.every((id) => selectedRowIds.has(id));
}

/**
 * 消えた行を選択から外す。
 *
 * 勤務や回転を削除しても選択が残ると、「n件選択中」が減らないうえ、画面に無い車両が
 * 自動配車や運賃計算の対象に入る（指摘 2026/08/19）。
 *
 * 判定は「その行がまだ在るか」だけで、絞り込みで隠れている行は落とさない。
 * 呼び出し側が絞り込み前（表示条件を掛ける前）の行 ID を渡す契約にしている。
 */
export function pruneSelectedRowIds(
  selectedRowIds: Set<string>,
  existingRowIds: ReadonlySet<string>,
): Set<string> {
  if (selectedRowIds.size === 0) return selectedRowIds;
  const next = new Set([...selectedRowIds].filter((id) => existingRowIds.has(id)));
  // 参照が変わると memo 済みの車両リストが毎回再描画される
  return next.size === selectedRowIds.size ? selectedRowIds : next;
}
